<template>
  <mavon-editor
    :class="withMaxHeight?'md':undefined"
    :value="value"
    :subfield="false"
    :defaultOpen="'preview'"
    :toolbarsFlag="false"
    :editable="false"
    :boxShadow="!noShadow"
    :scrollStyle="true"
  ></mavon-editor>
</template>

<script>
export default {
  name: "MarkdownDisplay",
  props: {
    value: String,
    noShadow: Boolean,
    withMaxHeight: Boolean
  }
};
</script>

<style lang="scss" scoped>
.md.v-note-wrapper {
  max-height: 400px;
}
</style>